import ContentLoader from "@funded-here-interface/common/src/components/ContentLoader/ContentLoader";
import { Persona } from "@funded-here-interface/common/src/constant/enum";
import { IconPhotoDollar, IconSignature } from "@tabler/icons-react";
import { FC, ReactNode, Suspense, useState, useEffect } from "react";
import { useSelector } from "react-redux";

import NavBar from "../../components/NavBar/NavBar";
import SystemUpgradeModal from "../../components/SystemUpgradeModal/SystemUpgradeModal";
import { RootState } from "../../store";
import { useStyles } from "./Borrowerlayout.styles";

interface IProps {
  content: ReactNode;
}

const BorrowerLayout: FC<IProps> = ({ content }) => {
  const { classes } = useStyles();
  const { hasCreditLimit, declarationAISubmitted, type, hasSeenSignedAgreement } = useSelector(
    (state: RootState) => state.auth,
  );
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  // Show modal when declarationAISubmitted is true for non auth rep user of merchant, else check also hasSeenSignedAgreement
  useEffect(() => {
    if (
      (type !== Persona.AUTH_REP && declarationAISubmitted) ||
      (type === Persona.AUTH_REP && hasSeenSignedAgreement === true && declarationAISubmitted)
    ) {
      setShowUpgradeModal(true);
    }
  }, [declarationAISubmitted, type, hasSeenSignedAgreement]);

  const menus = [
    // {
    //   label: "Dashboard",
    //   path: "/merchant-dashboard/Overall",
    //   icon: <IconHome />,
    // },
    {
      label: "Collaboration Proposal",
      path: "/collaboration-proposal/submission",
      icon: <IconPhotoDollar />,
    },
    {
      label: "Signed Documents",
      path: "/signed-documents",
      icon: <IconSignature />,
    },
  ];

  return (
    <div className={classes.mainContainer}>
      {/* <div className={classes.sideBarContainer}>
        <div className={classes.iconbox}>
          <img className={classes.logo} alt="LOGO" src={LoginIcon} />
        </div>
        {hasCreditLimit && (
          <div>
            {menus.map((data, index) => (
              <>
                <div
                  key={index}
                  className={classes.sideDiv}
                  onClick={() => toggleSubMenu(index)}
                >
                  <Link to={data.path} className={classes.Link}>
                    {data.icon}
                    <p className={classes.label}> {data.label}</p>
                  </Link>
                </div>
              </>
            ))}
          </div>
        )}

        <div className={classes.labelLog} onClick={handleLogout}>
          <div className={classes.persona}>
            <Text>
              {name.firstName} {name.lastName}
            </Text>
          </div>
          <img src={logoutIcon} alt="Logout Icon" className={classes.icon} />
          Logout
        </div>
      </div> */}
      <NavBar menus={menus} canPassCondition={hasCreditLimit} />
      <SystemUpgradeModal opened={showUpgradeModal} onClose={() => setShowUpgradeModal(false)} />
      <div style={{ paddingBottom: "30px" }} className={classes.hero}>
        <Suspense fallback={<ContentLoader />}>{content}</Suspense>
      </div>
    </div>
  );
};

export default BorrowerLayout;
